export default {
  situacao: null,
  valorInicial: null,
  valorFinal: null,
  boardId: null,
  boardColumnId: null,
  codigo: null
}



// WEBPACK FOOTER //
// ./src/shared/models/configurations/movimentationmodel.js